import * as React from "react";
import config from "../../config/config";
import Overview from "../../components/OverviewTable/Overview";
import t from "../../hooks/useTranslation";
import useDetailData from "../../hooks/useDetailData";
import AppConfigForm from "./AppConfigForm";

import './Settings.css';

function Settings(props) {
    const {isLoading, error, response} = useDetailData(config.apiRouteMap.appConfig);

    return (
        <div className="Settings app__main">
            <Overview
                isLoading={isLoading}
                title={t('appConfigSettings')}
                error={error}
            >
                <AppConfigForm
                    history={props.history}
                    data={response}
                    isLoading={isLoading}
                    error={error}
                />
            </Overview>
        </div>
    );
}

export default Settings;
